/**
 * moniteurRoutes.jsx — Routes Espace enseignant / moniteur (/moniteur/*)
 * Rôles : enseignant | admin.
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import MoniteurLayout from '../components/MoniteurLayout';
import MoniteurPlanning from '../pages/moniteur/PlanningPage';
import MoniteurDashboard from '../pages/moniteur/DashboardPage';
import MoniteurEleves from '../pages/moniteur/ElevesPage';
import MoniteurBilans from '../pages/moniteur/BilansPage';
import MoniteurProgression from '../pages/moniteur/ProgressionPage';
import MoniteurMessages from '../pages/moniteur/MessagesPage';
import ContactAdminPage from '../pages/ContactAdminPage';
import MaFichePage from '../pages/moniteur/MaFichePage';
import MoniteurMaCartePage from '../pages/moniteur/MaCartePage';
import CoursAPartager from '../pages/moniteur/CoursAPartager';
import MoniteurShortsPage from '../pages/moniteur/MoniteurShortsPage';

export const MoniteurRoutes = () => (
  <Route path="/moniteur" element={
    <ProtectedRoute roles={['enseignant', 'admin']}>
      <MoniteurLayout />
    </ProtectedRoute>
  }>
    <Route index element={<Navigate to="/moniteur/planning" replace />} />
    <Route path="planning" element={<MoniteurPlanning />} />
    <Route path="dashboard" element={<MoniteurDashboard />} />
    <Route path="eleves" element={<MoniteurEleves />} />
    <Route path="bilans" element={<MoniteurBilans />} />
    <Route path="progression" element={<MoniteurProgression />} />
    <Route path="messages" element={<MoniteurMessages />} />
    <Route path="ma-fiche" element={<MaFichePage />} />
    <Route path="ma-carte" element={<MoniteurMaCartePage />} />
    <Route path="cours-a-partager" element={<CoursAPartager />} />
    <Route path="shorts" element={<MoniteurShortsPage />} />
    <Route path="contact-admin" element={<ContactAdminPage />} />
  </Route>
);

export default MoniteurRoutes;
